import React, { useState } from 'react';
import styled from 'styled-components';
import RecoverySidebar from './RecoverySidebar';
import RecoveryTopBar from './RecoveryTopBar';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f1f5f9;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${(p) => (p.$sidebarOpen ? '256px' : '80px')};
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  background: #f1f5f9;
  padding: 24px;
`;

export default function RecoveryLayout({ children, title, currentSection }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <Root>
      <RecoverySidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} currentSection={currentSection} />
      <Main $sidebarOpen={sidebarOpen}>
        <RecoveryTopBar title={title} onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <Content>{children}</Content>
      </Main>
    </Root>
  );
}
